import stagingapis from "./stagingapis";
export const prodapis = {
    ...stagingapis
}

export default prodapis;